"use strict";

var _classCallCheck = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_inputrules_1 = require("prosemirror-inputrules");

var toggleList_1 = __importDefault(require("../commands/toggleList"));

var Node_1 = __importDefault(require("./Node"));

var BulletList =
/*#__PURE__*/
function (_Node_1$default) {
  _inherits(BulletList, _Node_1$default);

  function BulletList() {
    _classCallCheck(this, BulletList);

    return _possibleConstructorReturn(this, _getPrototypeOf(BulletList).apply(this, arguments));
  }

  _createClass(BulletList, [{
    key: "commands",
    value: function commands(_ref) {
      var type = _ref.type,
          schema = _ref.schema;
      return function () {
        return toggleList_1.default(type, schema.nodes.list_item);
      };
    }
  }, {
    key: "keys",
    value: function keys(_ref2) {
      var type = _ref2.type,
          schema = _ref2.schema;
      return {
        "Shift-Ctrl-8": toggleList_1.default(type, schema.nodes.list_item)
      };
    }
  }, {
    key: "inputRules",
    value: function inputRules(_ref3) {
      var type = _ref3.type;
      return [prosemirror_inputrules_1.wrappingInputRule(/^\s*([-+*])\s$/, type)];
    }
  }, {
    key: "toMarkdown",
    value: function toMarkdown(state, node) {
      state.renderList(node, "  ", function () {
        return (node.attrs.bullet || "*") + " ";
      });
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return {
        block: "bullet_list"
      };
    }
  }, {
    key: "name",
    get: function get() {
      return "bullet_list";
    }
  }, {
    key: "schema",
    get: function get() {
      return {
        content: "list_item+",
        group: "block",
        parseDOM: [{
          tag: "ul"
        }],
        toDOM: function toDOM() {
          return ["ul", 0];
        }
      };
    }
  }]);

  return BulletList;
}(Node_1.default);

exports.default = BulletList;